import React, { useState } from 'react';
import { HiOutlineKey, HiOutlineUserCircle } from 'react-icons/hi2';
import ReauthField from './ReauthField';
import ReauthForm from './ReauthForm';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import { REAUTH_TEXT_KEYS } from './reauthTexts';

const ReauthPasswordForm = ({ defaultUsername = '', isSubmitting = false, onSubmit, onLeave }) => {
  const [username, setUsername] = useState(defaultUsername);
  const [password, setPassword] = useState('');

  const { tempedgeTranslator: text } = useTempEdgeTranslator();
  const isKnownUser = Boolean(defaultUsername);
  const accountTag = isKnownUser && (
    <span className="reauth-account-tag" data-testid="reauth-known-user">
      <HiOutlineUserCircle aria-hidden="true" />
      {defaultUsername}
    </span>
  );
  const canSubmit = Boolean(username.trim() && password) && !isSubmitting;

  const handleSubmit = () => onSubmit({ username: username.trim(), password });

  const handleUsernameChange = (event) => setUsername(event.target.value);

  const handlePasswordChange = (event) => setPassword(event.target.value);

  return (
    <ReauthForm
      testId="reauth-password-form"
      canSubmit={canSubmit}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      onLeave={onLeave}
      submitTestId="reauth-submit-button"
    >
      {!isKnownUser && (
        <ReauthField
          id="reauth-username"
          label={text(REAUTH_TEXT_KEYS.username)}
          value={username}
          onChange={handleUsernameChange}
          autoComplete="username"
        />
      )}
      <ReauthField
        id="reauth-password"
        label={text(REAUTH_TEXT_KEYS.password)}
        labelAside={accountTag}
        value={password}
        onChange={handlePasswordChange}
        autoComplete="current-password"
        icon={HiOutlineKey}
        autoFocus
        isPassword
      />
    </ReauthForm>
  );
};

export default ReauthPasswordForm;
